module.exports = __webpack_public_path__ + "img/01.395d3222.png";